import { PropType, ExtractPropTypes } from 'vue'
export interface CascaderOption {
  text: string
  value: string | number
  color?: string
  children?: CascaderOption[]
  disabled?: boolean
  className?: string
}

export interface selectedValue {
  value: string | number
  selectedOptions: CascaderOption[]
  tabIndex: number
}

export interface FieldNames {
  text?: string
  value?: string
  children?: FieldNames[]
}

export interface Area {
  areaCode: number
  areaName: string
  id?: number
}

export interface AreaTreeItem {
  areaCode: number | string
  areaName: string
  childAreaList?: AreaTreeItem[] | null
  areaType?: number
  id?: number
  parentId?: number
}

export interface AreaItem {
  label: string
  value: number
  nextValue: number
  code?: number
  list: AreaTreeItem[]
}

export type OptionType = {
  label: string
  [key: string]: unknown
}

export const selectAreaProps = {
  areaCode: {
    type: [String, Number],
    default: ''
  },
  areaTree: {
    type: Array as PropType<AreaTreeItem[]>,
    default: () => []
  },
  allowClear: {
    type: Boolean,
    default: true
  },
  border: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholderTip: {
    type: Array,
    default: () => []
  },
  showSearch: {
    type: Boolean,
    default: true
  },
  areaNum: {
    type: Number,
    default: 4
  },
  ipadAsPc: {
    type: Boolean,
    default: false
  }
}

export function getProvince(val: number | string): number {
  const valStr = String(val)
  const valueStr = valStr.substring(0, 2)
  return Number(valueStr)
}

export function getCity(val: number | string): number {
  const valStr = String(val)
  if (valStr.length >= 4) {
    const valueStr = valStr.substring(0, 4)
    return Number(valueStr)
  } else {
    return -1
  }
}

export function getDistrict(val: number | string): number {
  const valStr = String(val)
  if (valStr.length >= 6) {
    const valueStr = valStr.substring(0, 6)
    return Number(valueStr)
  } else {
    return -1
  }
}

export function getStreet(val: number | string): number {
  const valStr = String(val)
  if (valStr.length === 9) {
    const valueStr = valStr.substring(0, 9)
    return Number(valueStr)
  } else {
    return -1
  }
}

export type SelectAreaProps = ExtractPropTypes<typeof selectAreaProps>
